<template>
  <div class="card mt-1 no-mobile">
    <div class="table-responsive" v-on:scroll.passive="handleScroll">
      <div class="table-controls m-3">
        <h5 style="font-weight: 700">Jobs</h5>
        <div class="controls-wrap d-flex">
          <!-- Integration Field -->

          <input
            type="search"
            id="integration-search"
            class="form-control mr-2"
            aria-label="SearchGrid"
            aria-describedby="searchGrid"
            placeholder="Search (title and description)"
            v-model="searchKeyWord"
            @input="doSearch"
          />
          <div class="wrapper d-flex align-items-start">
            <!-- Published checkbox -->
            <div class="d-flex align-items-center">
              <div class="custom-control custom-checkbox mr-4 ml-auto">
                <input
                  @change="doSearch"
                  v-model="isPublished"
                  id="published"
                  class="mr-2 custom-control-input"
                  type="checkbox"
                  aria-label
                />
                <label style="white-space: nowrap" class="custom-control-label" for="published"
                  >Published</label
                >
              </div>

              <div class="service-level-select">
                <v-select
                  class="w-100"
                  @input="doSearch"
                  v-model="serviceLevelSelectModel"
                  placeholder="Service level"
                  inputId="service-level-select"
                  :options="[
                    { id: 0, service: 'Basic' },
                    { id: 1, service: 'Sourcing' },
                    { id: 2, service: 'Full-service' },
                  ]"
                  label="service"
                  :reduce="service => service"
                  :clearable="false"
                  multiple
                ></v-select>
              </div>
            </div>
          </div>

          <!-- Add Job btn -->
          <router-link
            :to="{ name: 'add-job-mobile' }"
            type="button"
            class="ml-auto btn btn-success text-nowrap m-button"
          >
            Add Job
          </router-link>
          <button
            type="button"
            class="btn btn-success ml-2 text-nowrap desktop-only"
            @click="onAddJobClick"
          >
            Add Job
            <portal to="add-job-modal">
              <CustomMainModal @close="onCloseAddJobModal" v-show="showModal">
                <template v-slot:header>
                  <h5>Add Job</h5>
                </template>
                <AddJobBtnModal v-if="showModal" />
              </CustomMainModal>
            </portal>
          </button>
          <portal-target name="add-job-modal"></portal-target>
        </div>
      </div>

      <!-- Mobile Interface -->
      <section class="candidate-mobile mt-4 mobile-only">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <ul class="list-unstyled">
                <li v-for="(jobAd, $index) in infiniteScrollList" :key="$index" class="mb-3">
                  <router-link
                    class="username mb-2"
                    :to="{ name: 'job_uuid', params: { job_uuid: jobAd.uuid } }"
                    >{{ jobAd.title }}</router-link
                  >
                  <div class="d-flex main mb-1">
                    <span>{{ jobAd.employer_id }}</span>
                    <span>8 Hours ago</span>
                  </div>
                  <div class="d-flex mb-2">
                    <span>{{ getLocation(jobAd) }}</span>
                    <span> <span class="status employment"></span> {{ getStatus }} </span>
                  </div>
                  <div class="collapse" id="collapseExample">
                    <ul class="list-inline stats">
                      <li class="list-inline-item w-20"><span>12</span> not contacted</li>
                      <li class="list-inline-item"><span>12</span> contacted</li>
                      <li class="list-inline-item"><span>12</span> Interviewing</li>
                      <li class="list-inline-item"><span>12</span> offered</li>
                      <li class="list-inline-item"><span>12</span> hired</li>
                    </ul>
                  </div>
                  <a
                    class="toggle-collapse"
                    data-toggle="collapse"
                    href="#collapseExample"
                    role="button"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                  >
                    <i class="fas fa-chevron-down"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <infinite-loading
          @infinite="infiniteHandler"
          force-use-infinite-wrapper="true"
          spinner="waveDots"
        ></infinite-loading>
      </section>
      <!-- End mobile Interface -->

      <div style="position: relative">
        <table class="table table-striped custom-table desktop-only-table">
          <thead class="bg-dark">
            <tr>
              <th
                id="col-title"
                class="sticky"
                :style="stylesObj"
                style="width: 240px"
                scope="col"
                nowrap
              >
                TITLE
              </th>
              <th nowrap scope="col">LOCATION</th>
              <th nowrap scope="col">&nbsp;</th>
              <th nowrap scope="col" style="width: 10%">UPDATED</th>
              <th nowrap style="width: 10%" scope="col">STATUS</th>
              <th nowrap scope="col">PIPELINE STATISTICS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="jobAd in getJobsForCurrentEmployer.data" :key="jobAd.uuid">
              <td id="title" class="popover-show" :style="stylesObj" nowrap>
                <popper
                  trigger="hover"
                  :options="{
                    placement: 'top',
                    modifiers: { offset: { offset: '0,10px' } },
                  }"
                >
                  <span class="popper">
                    {{ jobAd.title }}
                  </span>
                  <span slot="reference">
                    <router-link
                      slot="reference"
                      :to="{
                        name: 'job_uuid',
                        params: { job_uuid: jobAd.id, job_name: jobAd.title },
                      }"
                    >
                      {{ jobAd.title }}
                    </router-link>
                  </span>
                </popper>
              </td>
              <td nowrap>{{ getLocation(jobAd) }}</td>
              <td nowrap>
                <div class="popover-show mx-auto" style="width: 25px; height: auto">
                  <svgHelper
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="serviceLevel(jobAd.service_level).title"
                    :name="serviceLevel(jobAd.service_level).title"
                  />
                </div>
              </td>
              <td nowrap id="updated-at">
                <popper
                  trigger="hover"
                  :options="{
                    placement: 'top',
                    modifiers: { offset: { offset: '0,10px' } },
                  }"
                >
                  <span class="popper">
                    {{
                      jobAd.updated_at
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: true,
                        })
                    }}
                  </span>
                  <span slot="reference">
                    {{
                      jobAd.updated_at
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}
                  </span>
                </popper>
              </td>

              <td id="status" align="center">
                <div class="d-flex align-items-center">
                  <div
                    :class="[
                      getStatusColorClass(jobAd.status),
                      'flex-shrink-0',
                      'stage-size',
                      'rounded-circle',
                      'mr-2',
                    ]"
                  ></div>
                  <span
                    class="stage-text"
                    :class="getStatusTitle(jobAd.status).status !== '' ? 'text-nowrap' : 'mr-0'"
                    >{{ getStatusTitle(jobAd.status).status }}</span
                  >
                </div>

                <!--  <div class="status">
                <div class="status-color-closed status-custom">
                  <p>
                    {{ 'Closed' }}
                  </p>
                </div>
              </div> -->
              </td>
              <td id="pipeline-statistics">
                <!--  {{ jobAd.statistics }} -->
                <!--  	{ "not_submitted": 68, "not_contacted": 2, "contacted": 0, "interviewing": 0, "offered_employment": 0, "employed": 0, "not_interested": 1, "not_considered": 2 } -->
                <ul
                  v-if="jobAd.statistics"
                  class="stats-labels d-none d-sm-none d-xs-none d-md-none d-lg-none d-xl-flex"
                >
                  <li
                    v-show="
                      jobAd.statistics.not_contacted !== 0 &&
                        jobAd.statistics.not_contacted !== null
                    "
                    class="stats-labels-item color-grey"
                  >
                    <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                      <div class="popper">Not contacted</div>
                      <router-link to slot="reference" class="text-white">{{
                        jobAd.statistics.not_contacted
                      }}</router-link>
                    </popper>
                  </li>
                  <li
                    v-show="jobAd.statistics.contacted !== 0 && jobAd.statistics.contacted !== null"
                    class="stats-labels-item color-light-grey"
                  >
                    <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                      <div class="popper">Contacted</div>
                      <router-link to href slot="reference" class="text-white">{{
                        jobAd.statistics.contacted
                      }}</router-link>
                    </popper>
                  </li>
                  <li
                    v-show="
                      jobAd.statistics.interviewing !== 0 && jobAd.statistics.interviewing !== null
                    "
                    class="stats-labels-item color-blue"
                  >
                    <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                      <div class="popper">Interviewing</div>
                      <router-link to href slot="reference" class="text-white">{{
                        jobAd.statistics.interviewing
                      }}</router-link>
                    </popper>
                  </li>
                  <li
                    v-show="
                      jobAd.statistics.offered_employment !== 0 &&
                        jobAd.statistics.offered_employment !== null
                    "
                    class="stats-labels-item color-light-blue"
                  >
                    <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                      <div class="popper">Offered employment</div>
                      <router-link to href slot="reference" class="text-white">{{
                        jobAd.statistics.offered_employment
                      }}</router-link>
                    </popper>
                  </li>
                  <li
                    v-show="jobAd.statistics.employed !== 0 && jobAd.statistics.employed !== null"
                    class="stats-labels-item color-green"
                  >
                    <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                      <div class="popper">Employed</div>
                      <router-link to href slot="reference" class="text-white">{{
                        jobAd.statistics.employed
                      }}</router-link>
                    </popper>
                  </li>
                </ul>
                <span v-else>N/A</span>
              </td>
            </tr>
          </tbody>
        </table>
        <Spinner :isLoading="isLoading" />
        <ErrorList
          class="no-data-message"
          v-show="getJobsForCurrentEmployer.data === 0"
          name="noJobs"
        />
      </div>
    </div>

    <span class="bottom-controls ml-auto w-10">
      <div id="pagination" class="desktop-only">
        <!-- Pagination -->
        <Pagination
          :currentPage="currentPage"
          :totalPages="totalPages"
          @nextPage="nextPage"
          @prevPage="previousPage"
          @keyup="keymonitor"
          @selectPageByNumber="setPageBynumber"
          @firstPage="setToFirstPage"
          @lastPage="setToLastPage"
        ></Pagination>
        &nbsp;
      </div>
    </span>
  </div>
</template>

<script>
import axios from 'axios';
import { statusMapper } from '@/utils/helpers';

import { mapGetters, mapActions } from 'vuex';

/* import Search from '../../common/Search/Search'; */
import AddJobBtnModal from '../Jobs/AddJobBtnModal';
import CustomMainModal from '../../Modals/CustomMainModal';
import ErrorList from '@/components/common/errorsList';
import svgHelper from '../../common/svgHelper';

import { stagesMixin } from '../../../mixins/stagesMixin';
import { statusMixin } from '../../../mixins/statusMixin';

import { displayResultsBasedOnScreenHeightMixin } from '../../../mixins/displayResultsBasedOnScreenHeightMixin';

import { serviceLevelMixin } from '../../../mixins/serviceLevelMixin';

import Pagination from '@/components/Navigations/Pagination';
// import AddBtn from '../common/TableControlsAddBtn';
/* import PipelineStats from '../../common/PipelineStatistics/PipelineStatistics'; */

export default {
  mixins: [stagesMixin, displayResultsBasedOnScreenHeightMixin, statusMixin, serviceLevelMixin],
  components: {
    CustomMainModal,
    /*   Search, */
    AddJobBtnModal,
    ErrorList,
    Pagination,
    svgHelper,
    /*  PipelineStats, */
  },
  data: () => ({
    /* Filters */
    searchKeyWord: '',
    locationsOptions: [],
    citiesByNameOptions: [],
    selectedFilterName: [],
    filters: [],
    listOfFilters: [],
    /* End Filters */
    stylesObj: {
      boxShadow: '',
    },
    listOfSelectedEmployers: [],

    serviceLevelSelectModel: [],
    searchText: '',
    infiniteScrollList: [],
    toggleFilter: false,
    showModal: false,
    isPublished: false,
    currentPage: 1,
    pageCount: 10,
    totalPages: 1,
    isLoading: false,
    newEmployerData: {},
  }),
  methods: {
    ...mapActions([
      'retrieveEmployersDropdown',
      'retrieveJobsForEmployer',
      'retrieveCompetencesList',
      'searchLocationByName',
      'retrieveAllCountries',
      'retrieveReviewJobs',
      'retrieveJobAds',
      'retrieveEmployerById',
    ]),
    onCloseAddJobModal() {
      this.showModal = false;
    },
    onAddJobClick() {
      this.showModal = true;
    },
    /* Filters */
    /* selectedFilterType(e) {
      if (e.target.value == 'employment') {
        this.filters.forEach((el) => {
          if (el && Object.keys(el).length === 0) {
            el['employment'] = '1';
          }
        });
      }

      if (e.target.value == 'relocation') {
        this.filters.forEach((el) => {
          if (el && Object.keys(el).length === 0) {
            el['relocation'] = false;
          }
        });
      }
    }, */
    /*  handleVSelectFields(inputValue, filterType) {
      console.log(filterType, '|', inputValue);
    }, */
    fetchOptions(search, loading) {
      if (search.length < 3) {
        this.locationsOptions = [];
      }

      if (search.length >= 3) {
        loading(true);

        this.searchLocationByName(search)
          .then(response => {
            const citiesList = response.data.cities;
            const countriesList = response.data.countries;

            const concatedLists = [].concat(countriesList, citiesList);

            this.locationsOptions = concatedLists;

            loading(false);
          })
          .catch(() => {
            loading(false);
            /*  console.log(err); */
          });
      }
    },
    fetchOptionsForCities(search, loading) {
      if (search.length > 1) {
        loading(true);
        this.searchLocationByName(search)
          .then(response => {
            this.citiesByNameOptions = response.data.cities;

            loading(false);
          })
          .catch(() => {
            loading(false);
            /*   console.log(err); */
          });
      }
    },
    /* addFilter(_value, fieldType) {
      fieldType.push({});
      this.selectedFilterName.push('location');
    }, */
    /* removeSingleFilter(index, fieldType) {
      fieldType.splice(index, 1);
      this.selectedFilterName.splice(index, 1);

      this.reloadDefaultList();
    }, */
    /* removeAllFilters() {
      this.filters = [];
      this.selectedFilterName = [];

      this.reloadDefaultList();
    }, */
    /*   applyFilters() {
      // Remove invalid entries
      this.selectedFilterName.forEach((filterType, index) => {
        if (filterType == 'distance') {
          Object.keys(this.filters[index] || {}).forEach((key) =>
            this.selectedFilterName.includes(key),
          );
        } else {
          Object.keys(this.filters[index] || {}).forEach(
            (key) => this.selectedFilterName.includes(key) || delete this.filters[index][key],
          );
        }
      });

      this.filters.forEach((item) => {
        if (item['location']) {
          let tempList = item.location.map((i) => i.id);

          this.listOfFilters.push({ location: tempList });

          // Send to API

          // console.log('location: ', this.listOfFilters);
        }

        if (item['city']) {
          this.listOfFilters.push({
            distance: {
              city_id: item['city'].id,
              distance: item['distance'] || 0,
            },
          });

          console.log('city: ', this.listOfFilters);
        }

        if (item['employment']) {
          this.listOfFilters.push({
            employment: Number(item.employment),
          });

          console.log('Employment type: ', this.listOfFilters);
        }

        if (item['competences']) {
          this.listOfFilters.push(item);

          console.log('competences: ', this.listOfFilters);
        }

        if (item['relocation'] == true || item['relocation'] == false) {
          console.log('relocation: ', item);

          this.listOfFilters.push({
            relocation: item.relocation,
          });

          console.log('relocation: ', this.listOfFilters);
        }
      });

      console.log('final: ', this.listOfFilters);

      this.doSearchWithFilters(this.listOfFilters);

      //Reset List
      this.listOfFilters = [];
    }, */
    /*     doSearchWithFilters(filters) {
      this.isLoading = true;
      this.currentPage = 1;

      this.selectedFiltersList = filters;

      this.retrieveJobAds({
        search_word: this.searchKeyWord,
        page: this.currentPage,
        count: this.pageCount,
        published: this.isPublished,
        employersList: this.listOfSelectedEmployers.map((item) => item.id),
        filters: filters,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          throw err;
        });
    }, */
    /* reloadDefaultList() {
      this.isLoading = true;

      this.selectedFiltersList = [];
      this.currentPage = 1;

      this.retrieveJobAds({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        optedOut: this.isOptedOut,
        employersList: this.listOfSelectedEmployers.map((item) => item.id),
        filters: [],
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;

          if (err.response.status == 401) {
            localStorageHelper();

            this.$toasted.error('Your session is expired!', {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            });

            this.$router.push({ name: 'home' });
            location.reload();
          }

          this.isLoading = false;
          throw err;
        });
    }, */
    /* End Filters */
    doSearch() {
      this.currentPage = 1;

      this.isLoading = true;

      this.retrieveJobsForEmployer({
        employerId: this.$route.params.employer_id,
        search_word: this.searchKeyWord,
        service_level: this.serviceLevelSelectModel.map(item => item.id),
        published: this.isPublished,
        page: this.currentPage,
        count: this.pageCount,
      })
        .then(res => {
          this.isLoading = false;
          this.totalPages = res.data.last_page;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    infiniteHandler($state) {
      axios
        .get(`http://test4shark.jobshark.se/api/jobadsList`, {
          params: {
            page: this.currentPage,
            count: this.pageCount,
          },
          headers: {
            Authorization: `Bearer ${this.getToken}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          /*     console.log(data); */
          const list = data.data.result.data;

          if (list.length) {
            this.currentPage += 1;
            this.infiniteScrollList.push(...list);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
    },
    handleSearchFilters() {
      /*  this.isLoading = true;

      this.retrieveJobAds({
        page: 1,
        count: this.pageCount,
        search_word: this.searchText,
        employerUuid: this.selectedEmployerUuid,
        published: this.isPublished,
        employersList: this.listOfSelectedEmployers.map(item => item.id),
        service_level: this.serviceLevelSelectModel.map(item => item.id),
        filters: this.filters,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          throw err;
        });
      /* else {
        this.retrieveJobAds({
          page: 1,
          count: this.pageCount,
          employerUuid: '',
          optedOut: this.isOptedOut,
        });
      } */
    },
    nextPage() {
      if (this.currentPage >= 1 && this.currentPage < this.totalPages) {
        this.isLoading = true;
        this.currentPage++;

        this.retrieveJobsForEmployer({
          employerId: this.$route.params.employer_id,
          search_word: this.searchText,
          service_level: [],
          published: this.isPublished,
          page: this.currentPage,
          count: this.pageCount,
        })
          .then(res => {
            this.isLoading = false;
            this.totalPages = res.data.last_page;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.isLoading = true;
        --this.currentPage;

        this.retrieveJobsForEmployer({
          employerId: this.$route.params.employer_id,
          search_word: this.searchText,
          service_level: [],
          published: this.isPublished,
          page: this.currentPage,
          count: this.pageCount,
        })
          .then(res => {
            this.isLoading = false;
            this.totalPages = res.data.last_page;
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        this.currentPage = 1;
      }
    },
    setToFirstPage() {
      this.isLoading = true;
      this.currentPage = 1;

      this.retrieveJobsForEmployer({
        employerId: this.$route.params.employer_id,
        search_word: this.searchText,
        service_level: [],
        published: this.isPublished,
        page: this.currentPage,
        count: this.pageCount,
      })
        .then(res => {
          this.isLoading = false;
          this.totalPages = res.data.last_page;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    setToLastPage(lastPage) {
      this.isLoading = true;
      this.currentPage = lastPage;

      this.retrieveJobsForEmployer({
        employerId: this.$route.params.employer_id,
        search_word: this.searchText,
        service_level: [],
        published: this.isPublished,
        page: this.currentPage,
        count: this.pageCount,
      })
        .then(res => {
          this.isLoading = false;
          this.totalPages = res.data.last_page;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    setPageBynumber(pageNumber) {
      if (pageNumber > this.totalPages || pageNumber < 1) return;
      this.currentPage = pageNumber;

      this.retrieveJobsForEmployer({
        employerId: this.$route.params.employer_id,
        search_word: this.searchText,
        service_level: [],
        published: this.isPublished,
        page: this.currentPage,
        count: this.pageCount,
      })
        .then(res => {
          this.isLoading = false;
          this.totalPages = res.data.last_page;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleScroll(evt) {
      if (evt.target.scrollLeft > 0) {
        this.stylesObj.boxShadow = 'rgba(0,0,0,0.75) 7px 8px 17px -14px';
      } else {
        this.stylesObj.boxShadow = '';
      }
    },
    getLocation(jobAd) {
      if (jobAd.city && jobAd.country) {
        return `${jobAd.city.name}, ${jobAd.country.name}`;
      }

      return '';
    },
    keymonitor(event) {
      if (this.showModal) return;
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      if (keyMessage == 'ArrowRight') {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        this.previousPage();
      }
    },
  },
  watch: {
    showModal() {
      // document.body.style.overflow = this.showModal ? 'hidden' : '';
    },
    serviceLevelSelectModel() {
      const parsed = JSON.stringify(this.serviceLevelSelectModel);
      localStorage.setItem('joblistServiceLevel', parsed);
    },
    listOfSelectedEmployers() {
      const parsed = JSON.stringify(this.listOfSelectedEmployers);
      localStorage.setItem('listOfSelectedEmployers', parsed);
    },
    isPublished() {
      localStorage.isPublished = this.isPublished;
    },
  },
  computed: {
    ...mapGetters([
      'getToken',
      'getNextPage',
      'getUserProfile',
      'getCurrentPage',
      'getAllCountries',
      'getCitiesByName',
      'getJobsForEmployer',
      'getEmployersDropdown',
      'getCompetencesFilterList',
      'getJobsForCurrentEmployer',
      'getEmployerById',
    ]),
    getStatus() {
      return statusMapper('6');
    },
  },
  mounted() {
    // this.displayResultsBasedOnScreen();

    /*  if (localStorage.joblistServiceLevel)
      this.serviceLevelSelectModel = JSON.parse(localStorage.joblistServiceLevel);

    if (localStorage.listOfSelectedEmployers)
      this.listOfSelectedEmployers = JSON.parse(localStorage.listOfSelectedEmployers);

    if (localStorage.isPublished) this.isPublished = JSON.parse(localStorage.isPublished); */

    this.isLoading = true;

    this.retrieveJobsForEmployer({
      employerId: this.$route.params.employer_id,
      search_word: this.searchText,
      service_level: [],
      published: this.isPublished,
      page: this.currentPage,
      count: this.pageCount,
    })
      .then(res => {
        this.isLoading = false;
        console.log(res);
        this.totalPages = res.data.last_page;
      })
      .catch(() => {
        this.isLoading = false;
      });

    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/_mixins.scss';

.icon-wrapper {
  .svg-icon {
    width: 18px;
    height: 18px;
  }

  .edit {
    fill: #a7a7a7;
  }

  .submit {
    fill: #5bb75b;
  }
}

.btn-success {
  align-self: start;
}

.m-button {
  display: none;
}

.custom-table {
  min-width: 100%;
  tr {
    td {
      &:first-of-type {
        padding-left: 21px;
        a {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
        }
      }
    }
  }
}

.table-responsive {
  overflow: unset;
  min-height: 500px;
}

select {
  min-width: 110px;
  box-shadow: 0px 2px 3px #0000000d;
  border: 1px solid #d7dae2;
  border-radius: 4px;
}

#stage {
  .stage-size {
    width: 12px;
    height: 12px;
  }

  .stage-color-new {
    background-color: #4ca7d5;
  }
  .stage-color-draft {
    background-color: #8a8b8a;
  }
  .stage-color-active {
    background-color: #419941;
  }
  .stage-color-expired {
    background-color: #f17931;
  }
  .stage-color-rejected {
    background-color: #f02800;
  }
}

/* Pipeline statistics */
#pipeline-statistics {
  position: relative;

  .stats-labels {
    position: absolute;
    top: 50%;
    left: 0%;
    transform: translate(0%, -50%);
    opacity: 0.75;
    list-style-type: none;
    margin: 0;
    padding: 0;
    font-family: Lato;
    font-size: 11px;

    .stats-labels-item {
      span {
        padding: 5px;
        color: #fff;
      }

      // float: left;
      clip-path: polygon(85% 0, 100% 50%, 85% 100%, 0 100%, 10% 50%, 0 0);
      // height: 8px;
      padding: 0.4rem 1rem 0.4rem 1rem;
      margin-right: -10px;
    }

    .color-grey {
      background: #333;
    }

    .color-light-grey {
      background: #747674;
    }

    .color-blue {
      background: #465c74;
    }

    .color-light-blue {
      background: #066da1;
    }

    .color-green {
      background: #148214;
    }

    .color-light-green {
      background: #5bb75b;
    }

    .color-dark-red {
      background: #913d8b;
    }

    .color-red {
      background: #f02800;
    }

    span:nth-child(1) {
      font-size: 14px;
      font-weight: bold;
      margin-right: 10px;
    }

    span:nth-child(2) {
      font-weight: 300;
    }
  }
}

/* #col-title,
#title:not([data-scroll='0']) {
  -webkit-box-shadow: 10px 5px 17px -14px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 10px 5px 17px -14px rgba(0, 0, 0, 0.75);
  box-shadow: 10px 5px 17px -14px rgba(0, 0, 0, 0.75);
} */
.published-mobile {
  display: none !important;
}

.employer-select {
  flex: 1;
}

.mobile-only {
  display: none !important;
}

.desktop-only {
  display: block;
}
.desktop-only-table {
  display: table;
}
.wrapper {
  width: 88.5%;
}
.service-level-select,
.employer-level-select {
  width: 50%;
}

.card {
  height: auto !important;
  padding-bottom: 0 !important;
}

@media only screen and (max-width: 1251px) {
  .card {
    margin: 24px 23px 0 23px !important;
  }
}

@media only screen and (max-width: 992px) {
  .m-button {
    display: inline-block;
    float: right;
    margin-top: 12px;
  }
  .card {
    margin-top: 26px !important;
    border-top-left-radius: 18px !important;
    border-top-right-radius: 18px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .mobile-only {
    display: block !important;
  }
  .integration-group {
    margin: 0 !important;
  }
  .controls-wrap {
    display: block !important ;
    .published {
      display: none !important;
    }
    .published-mobile {
      display: inline-block !important;
    }
    .employer-select {
      width: 100% !important;
    }
    .form-control:first-child {
      margin: 15px 17px 15px 0 !important;
    }
  }
  .desktop-only {
    display: none;
  }
  .desktop-only-table {
    display: none;
  }
  .wrapper {
    width: 100%;
  }
  .service-level-select {
    margin-top: 12px;
  }
  .employer-level-select {
    margin-top: 12px;
  }
}

@media only screen and (max-width: 768px) {
  .card {
    margin-top: 24px !important;
  }
  .mobile-only {
    display: block !important;
  }
  .integration-group {
    margin: 0 !important;
  }
  .controls-wrap {
    display: block !important ;
    .published {
      display: none !important;
    }
    .published-mobile {
      display: inline-block !important;
    }
    .employer-select {
      width: 100% !important;
    }
    .form-control:first-child {
      margin: 15px 17px 15px 0 !important;
    }
  }
  .desktop-only {
    display: none;
  }
  .desktop-only-table {
    display: none;
  }
  .service-level-select,
  .employer-level-select {
    width: 100%;
  }
}
@media only screen and (max-width: 576px) {
  .card {
    margin-top: 0px !important;
  }
  .custom-table {
    display: none;
  }
  .integration-group {
    margin: 0 !important;
  }
  .controls-wrap {
    display: block !important ;
    .published {
      display: none !important;
    }
    .published-mobile {
      display: inline-block !important;
    }
    .employer-select {
      width: 100% !important;
    }
    .form-control:first-child {
      margin: 15px 17px 15px 0 !important;
    }
  }
  .mobile-only {
    display: block !important;
  }
  .service-level-select {
    margin-right: 0 !important;
  }
}

@media screen and (max-width: 1200px) {
  .stats-labels-data {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.vs--searchable .vs__dropdown-toggle {
  height: calc(1.5em + 0.75rem + 2px);
}

.col-md-8.filter {
  color: #6c757d;
  margin-bottom: 12px;
  font-family: $font-family-sans-lato;
}

.filter-select {
  min-width: 200px;
  max-width: 200px;
  margin-right: 6px !important;
  padding-bottom: 8px;
}
</style>
